// src/pages/AcceptInvite.jsx — accept a team invite and set up login
import { useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { acceptTeamInvite } from '../api/kailux'
import { supabase } from '../supabase'
import ErrorMessage from '../components/ErrorMessage'


import { T, alpha } from '../theme/theme'
export default function AcceptInvite() {
  const [params]   = useSearchParams()
  const token      = params.get('token') || ''
  const [password, setPassword] = useState('')
  const [confirm,  setConfirm]  = useState('')
  const [loading,  setLoading]  = useState(false)
  const [error,    setError]    = useState('')
  const [firmName, setFirmName] = useState('')
  const [done,     setDone]     = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!token) { setError('This invite link is missing its token.'); return }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return }
    if (password !== confirm) { setError('Passwords do not match'); return }
    setLoading(true); setError('')
    try {
      const data = await acceptTeamInvite(token, password)
      setFirmName(data.firm_name || '')
      setDone(true)
      // Sign them in immediately, same pattern as Signup.jsx
      const emailGuess = data.email
      if (emailGuess) {
        await supabase.auth.signInWithPassword({ email: emailGuess, password })
      }
      setTimeout(() => navigate('/dashboard'), 1200)
    } catch (err) {
      setError(err.response?.data?.detail || 'Could not accept this invite. It may be invalid or already used.')
      setLoading(false)
    }
  }

  return (
    <div style={{ minHeight:'100vh', background:T.bg, display:'flex',
      alignItems:'center', justifyContent:'center', padding:'20px',
      fontFamily:"'Outfit',sans-serif", color:T.tx }}>
      <div style={{ width:'100%', maxWidth:'380px', background:T.s1,
        border:`1px solid ${T.bd}`, borderRadius:'16px', padding:'32px' }}>

        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:'22px',
          fontWeight:'800', marginBottom:'6px' }}>
          {done ? `Welcome to ${firmName || 'the firm'}!` : 'Join your team on KaiLux'}
        </div>
        <div style={{ fontSize:'14px', color:T.mt, marginBottom:'22px' }}>
          {done
            ? 'Your account is set up — taking you to your dashboard…'
            : 'Set a password to activate your account and get full access.'}
        </div>

        {!done && (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom:'14px' }}>
              <label style={{ display:'block', fontSize:'10px', fontWeight:'700',
                color:T.lt, letterSpacing:'1px', marginBottom:'6px' }}>PASSWORD</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
                placeholder="Min 8 characters"
                style={{ width:'100%', padding:'12px 14px', background:T.s2,
                  border:`1px solid ${T.bd}`, borderRadius:'10px', color:T.tx,
                  fontSize:'14px', fontFamily:"'Outfit',sans-serif", outline:'none',
                  boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:'18px' }}>
              <label style={{ display:'block', fontSize:'10px', fontWeight:'700',
                color:T.lt, letterSpacing:'1px', marginBottom:'6px' }}>CONFIRM PASSWORD</label>
              <input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)}
                placeholder="Repeat password"
                style={{ width:'100%', padding:'12px 14px', background:T.s2,
                  border:`1px solid ${T.bd}`, borderRadius:'10px', color:T.tx,
                  fontSize:'14px', fontFamily:"'Outfit',sans-serif", outline:'none',
                  boxSizing:'border-box' }} />
            </div>

            {error && <ErrorMessage style={{ marginBottom:'14px' }}>{error}</ErrorMessage>}

            <button type="submit" disabled={loading}
              style={{ width:'100%', padding:'13px', borderRadius:'10px', border:'none',
                background: loading ? T.mt : T.prg,
                color:T.onpri, fontFamily:"'Outfit',sans-serif", fontSize:'15px',
                fontWeight:'800', cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Activating…' : 'Activate Account'}
            </button>
          </form>
        )}

        {!done && (
          <div style={{ textAlign:'center', marginTop:'18px', fontSize:'13px', color:T.mt }}>
            Already have an account? <Link to="/login" style={{ color:T.or }}>Log in</Link>
          </div>
        )}
      </div>
    </div>
  )
}
